import React, { useEffect, useState } from 'react';
export function PriceOffer() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setTimeout(() => setShow(true), 300);
  }, []);
  return <>
      {/* Animaciones */}
      <style data-id="element-96">
        {`
          @keyframes pulseSoft {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.05); }
          }

          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }

          .animate-fadeUp {
            animation: fadeUp 0.8s ease forwards;
          }

          .animate-pulseSoft {
            animation: pulseSoft 2.5s ease-in-out infinite;
          }
        `}
      </style>

      <section id="precio" className="py-20 px-6 bg-sage-green text-center overflow-hidden" data-id="element-97">
        <div className="max-w-4xl mx-auto" data-id="element-98">
          {/* BADGE */}
          <div className={`inline-block bg-white text-sage-green font-bold px-6 py-2 rounded-full text-lg mb-8 shadow-md transition-all duration-700 ${show ? 'opacity-100 scale-100 animate-pulseSoft' : 'opacity-0 scale-90'}`} data-id="element-99">
            74% DE DESCUENTO
            <br data-id="element-100" />
            SOLO HOY
          </div>

          {/* PRECIO */}
          <div className={`flex flex-col items-center justify-center mb-6 transition-all duration-700 ${show ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'}`} data-id="element-101">
            <span className="text-3xl text-white/60 line-through font-bold mb-2" data-id="element-102">
              $30.000 CLP
            </span>

            <span className="text-6xl md:text-8xl text-white font-fredoka drop-shadow-xl animate-pulseSoft" data-id="element-103">
              $3.900 CLP
            </span>
          </div>

          {/* MICRO COPY */}
          <p className={`text-xl text-white/90 font-medium mb-10 max-w-2xl mx-auto transition-all duration-700 ${show ? 'opacity-100' : 'opacity-0'}`} data-id="element-104">
            Menos que un cuaderno... pero puede transformar la vida espiritual
            de tu hijo para siempre.
          </p>

          {/* CTA */}
          <a href="https://pequeguia.lat/cart/42347593236583:1" target="_blank" rel="noopener noreferrer" className={`inline-block w-full md:w-auto bg-white text-sage-green font-bold text-xl md:text-2xl py-5 px-10 rounded-2xl shadow-xl transition-all duration-300 mb-4 ${show ? 'opacity-100 scale-100' : 'opacity-0 scale-95'} hover:shadow-2xl hover:scale-110 active:scale-95`} data-id="element-105">
            SÍ, QUIERO EMPEZAR HOY POR $3.900
          </a>

          {/* TRUST */}
          <p className="text-white/80 font-medium" data-id="element-106">
            Pago seguro • Acceso inmediato • Garantía 7 días
          </p>
        </div>
      </section>
    </>;
}